/**
 * Пресеты периода и период по умолчанию
 * =====================================
 *
 * Все даты — ЛОКАЛЬНЫЕ (как и в dateUtils): никакого toISOString, иначе в
 * часовых поясах восточнее UTC полночь сдвигается на предыдущие сутки.
 * Сегодняшний день неполный, поэтому пресеты заканчиваются ВЧЕРА.
 */

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
const endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

/** Пресеты «N дней»: N полных дней, заканчивая вчера (7 дней = вчера-6..вчера). */
export const DAYS_PRESETS = {
  last3days: 3,
  last7days: 7,
  last30days: 30,
  last90days: 90,
  last180days: 180,
  last360days: 360
};

/** Предыдущий полный календарный месяц: 1-е .. последнее число. */
export function getPreviousMonthRange(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const end = new Date(now.getFullYear(), now.getMonth(), 0);
  return { start: startOfDay(start), end: endOfDay(end) };
}

/**
 * Диапазон пресета или null для неизвестного имени.
 * 'today' оставлен как есть (явный выбор пользователя), остальные кончаются вчера.
 * currentMonth: 1-е число месяца .. вчера; 1-го числа завершённых суток в месяце
 * ещё нет — берём вчера..вчера (последний день прошлого месяца).
 */
export function getPresetRange(preset, now = new Date()) {
  const yesterday = addDays(now, -1);

  if (preset === 'today') {
    return { start: startOfDay(now), end: endOfDay(now) };
  }
  if (preset === 'yesterday') {
    return { start: startOfDay(yesterday), end: endOfDay(yesterday) };
  }
  if (preset === 'currentMonth') {
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    const start = monthStart > yesterday ? yesterday : monthStart;
    return { start: startOfDay(start), end: endOfDay(yesterday) };
  }
  const days = DAYS_PRESETS[preset];
  if (days) {
    return { start: startOfDay(addDays(yesterday, -(days - 1))), end: endOfDay(yesterday) };
  }
  return null;
}
